var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "tune"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_319_14486",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.151352,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_319_14486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "tune_2",
    d: "M11.5 20.6514V15.6514H12.5V17.6514H20.5V18.6514H12.5V20.6514H11.5ZM3.5 18.6514V17.6514H8.5V18.6514H3.5ZM7.5 14.6514V12.6514H3.5V11.6514H7.5V9.65135H8.5V14.6514H7.5ZM11.5 12.6514V11.6514H20.5V12.6514H11.5ZM15.5 8.65135V3.65135H16.5V5.65135H20.5V6.65135H16.5V8.65135H15.5ZM3.5 6.65135V5.65135H12.5V6.65135H3.5Z",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigMenuIcon);
export default __webpack_public_path__ + "static/media/config-menu-icon.ffcbd70402d66b5c9f15ffe92cc958b9.svg";
export { ForwardRef as ReactComponent };